export default __webpack_public_path__ + "static/media/logo_color.242d9bfb.svg";